const username = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;

const getAuthHeaders = () => {
    const base64Credentials = btoa(`${username}:${password}`);

    return {
        'Authorization': `Basic ${base64Credentials}`,
        'Content-Type': 'application/json'
    };
};

export default getAuthHeaders;